module.exports = __webpack_public_path__ + "static/img/下载模型.4eeee41.png";


//////////////////
// WEBPACK FOOTER
// ./src/3dapps/imgs/下载模型.png
// module id = sw/7
// module chunks = 2